import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { drawLabel } from './textUtils';
import { getThemeStyle } from '../theme';

class DecisionServiceView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const label = model.properties?.name || model.text?.value || '';
    const textFill = (model.graphModel?.__epxDmnTheme?.text?.fill) || '#212121';
    const dividerY = model.properties?.outputDecisionsHeight
      ? (y - height / 2) + model.properties.outputDecisionsHeight
      : (y - height / 2) + height / 2;

    return h('g', {}, [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
        fill: 'transparent',
      }),
      h('line', {
        x1: x - width / 2,
        y1: dividerY,
        x2: x + width / 2,
        y2: dividerY,
        stroke: style.stroke,
        strokeWidth: 1,
      }),
      drawLabel(h, label, x, y - height / 2 + 16, width - 16, { fontSize: 12, fontWeight: 600, fill: textFill }),
    ]);
  }

  getText() { return ''; }
}

class DecisionServiceModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 520;
    this.height = 260;
    this.radius = 16;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
    this.zIndex = -1;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'decisionService');
    style.stroke = t.stroke || '#096dd9';
    style.strokeWidth = t.strokeWidth || 2;
    style.fill = 'transparent';
    return style;
  }
}

export const DecisionService = {
  type: 'dmn:DecisionService',
  view: DecisionServiceView,
  model: DecisionServiceModel,
};
